// Services section accordion functionality
import $ from 'jquery';

class Accordion {
    constructor() {
        // Defining the elements
        this.panels = $(".panel");
        this.services = $(".service");
        this.events();
    }
    events() {
        // Initiating the first open panel
        this.initiatePanels();
        // Adding an event listener for click
        this.services.on("click", (e) => {
            // Reseting all the panels on click
            this.resetPanels();
            this.resetIcons();
            this.activatePanel(e.currentTarget.nextElementSibling);
            this.activateIcon(e.currentTarget.children);
        });
    }
    // Initiating panels function
    initiatePanels() {
        this.panels[0].style.maxHeight = this.panels[0].scrollHeight + "px";
        this.panels[0].style.marginBottom = 30 + "px";
    }
    // Resetting all the panels function
    resetPanels() {
        this.panels.each(function() {
            this.style.maxHeight = null;
            this.style.marginBottom = 0 + "px";
        });
    }
    // Resetting the svgs of active/disabled panel
    resetIcons() {
        this.services.each(function() {
            if(this.children[0].classList.contains("visible")){
                this.children[0].classList.toggle("visible");
                this.children[1].classList.toggle("visible");
            }
        })
    }
    // Activating the panel
    activatePanel(panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.style.marginBottom = 30 + "px";
    }
    //Activating the icon
    activateIcon(children) {
        children[0].classList.toggle("visible");
        children[1].classList.toggle("visible");
    }
}

export default Accordion